 
var showSave;
var DownloadAttributeSupport = 'download' in document.createElement('a');

var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
var URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
navigator.saveBlob = navigator.saveBlob || navigator.msSaveBlob || navigator.mozSaveBlob || navigator.webkitSaveBlob;
window.saveAs = window.saveAs || window.webkitSaveAs || window.mozSaveAs || window.msSaveAs;

var BrowserSupportedMimeTypes = {
    "image/jpeg": true,
    "image/png": true,
    "image/gif": true,
    "image/svg+xml": true,
    "image/bmp": true,
    "image/x-windows-bmp": true,
    "image/webp": true,
    "audio/wav": true,
    "audio/mpeg": true,
    "audio/webm": true,
    "audio/ogg": true,
    "video/mpeg": true,
    "video/webm": true,
    "video/ogg": true,
    "text/plain": true,
    "text/html": true,
    "text/xml": true,
    "application/xhtml+xml": true,
    "application/json": true
};

if ((BlobBuilder || typeof Blob !== "undefined") && navigator.saveBlob) {
    showSave = function (data, name, mimetype) {
        var blob;

        if (!mimetype)
            mimetype = "application/octet-stream";

        if (BlobBuilder) {
            var builder = new BlobBuilder();
            builder.append(data);
            blob = builder.getBlob(mimetype);
        } else {
            blob = new Blob([data], { type: mimetype });
        }

        if (!name)
            name = "Download.bin";

        if (window.saveAs) {
            window.saveAs(blob, name);
        }
        else {
            navigator.saveBlob(blob, name);
        }
    };
}
else if ((BlobBuilder || typeof Blob !== "undefined") && URL) {
    showSave = function (data, name, mimetype) {
        var blob, url;

        if (!mimetype)
            mimetype = "application/octet-stream";

        if (BlobBuilder) {
            var builder = new BlobBuilder();
            builder.append(data);
            blob = builder.getBlob(mimetype);
        } else {
            blob = new Blob([data], { type: mimetype });
        }

        if (DownloadAttributeSupport) {
            url = URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", name || "Download.bin");
            var event = document.createEvent('MouseEvents');
            event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
            link.dispatchEvent(event);
        }
        else {
            if (BrowserSupportedMimeTypes[mimetype.split(";")[0]] === true) {
                mimetype = "application/octet-stream";
            }

            url = URL.createObjectURL(blob);
            window.open(url, '_blank', '');
        }
        setTimeout(function () {
            URL.revokeObjectURL(url);
        }, 250);
    };
}
else if (!/\bMSIE\b/.test(navigator.userAgent)) {
    showSave = function (data, name, mimetype) {
        if (!mimetype)
            mimetype = "application/octet-stream";

        if (BrowserSupportedMimeTypes[mimetype.split(";")[0]] === true) {
            mimetype = "application/octet-stream";
        }

        window.open("data:" + mimetype + "," + encodeURIComponent(data), '_blank', '');
    };
}

var DashboardViewModel = function (_customerCode, _crmCode, connection) {
    //var NumberCardViewModel = function (loading, number, link, downloadLink) {
    //    var self = this;

    //    self.loading = ko.observable(loading);
    //    self.number = ko.observable(number);
    //    self.moreInfoLink = ko.observable(link);
    //    self.downloadLink = ko.observable(downloadLink);
    //};

    var self = this;
    self.customerTypes = ko.observableArray();
    self.custList = ko.observableArray();
    self.error = ko.observable();
    var dealsUri = '/api/Contracts';
    var assetsUri = '/api/Assets';
    var qrentSADealsUri = '/api/QrentSAContracts';
    var qrentSAAssetsUri = '/api/QrentSAAssets';

    var CompanyViewModel = function (name, baseUrl, noDeals, noAssets, noAssetsWithIntent, noAssetsOnExtension, noAssetsExpiring, noAssetsSettledEOT, noAssetsSettledPart) {
        var self = this;

        var NumberCardViewModel = function (loading, number, link, downloadLink) {
            var self = this;

            self.loading = ko.observable(loading);
            self.number = ko.observable(number);
            self.moreInfoLink = ko.observable(link);
            self.downloadLink = ko.observable(downloadLink);

            self.loading(false);
        };

        self.name = ko.observable(name);
        self.noDeals = ko.observable(new NumberCardViewModel(true, noDeals, baseUrl + '/Contracts?filterType=ActiveOnly', baseUrl + '/Contracts/Download?filterType=ActiveOnly&format=Excel'));
        self.noAssets = ko.observable(new NumberCardViewModel(true, noAssets, baseUrl + '/Assets?filterType=ActiveOnly', baseUrl + '/Contracts/Download?filterType=ActiveOnly&format=Excel'));
        self.noAssetsWithIntent = ko.observable(new NumberCardViewModel(true, noAssetsWithIntent, baseUrl + '/Assets?filterType=Intent', baseUrl + '/Contracts/Download?filterType=ActiveOnly&format=Excel'));
        self.noAssetsOnExtension = ko.observable(new NumberCardViewModel(true, noAssetsOnExtension, baseUrl + '/Assets?filterType=Extension', baseUrl + '/Contracts/Download?filterType=ActiveOnly&format=Excel'));
        self.noAssetsExpiring = ko.observable(new NumberCardViewModel(true, noAssetsExpiring, baseUrl + '/Assets?filterType=Expiring', baseUrl + '/Contracts/Download?filterType=ActiveOnly&format=Excel'));
        self.noAssetsSettledEOT = ko.observable(new NumberCardViewModel(true, noAssetsSettledEOT, baseUrl + '/Assets?filterType=AssetStatus', '/Assets/Download?filterType=AssetStatus&format=Excel'));
        self.noAssetsSettledPart = ko.observable(new NumberCardViewModel(true, noAssetsSettledPart, baseUrl + '/Assets?filterType=Settled', '/Assets/Download?filterType=Settled&format=Excel'));
    };

    self.companies = ko.observableArray();

    //self.noDeals = ko.observable(new NumberCardViewModel(true, 0, '/Contracts?filterType=ActiveOnly', '/Contracts/Download?filterType=ActiveOnly&format=Excel'));
    //self.noLFSDeals = ko.observable(new NumberCardViewModel(true, 0, '/Contracts?filterType=ActiveOnly', '/Contracts/Download?filterType=ActiveOnly&format=Excel'));
    //self.noAssets = ko.observable(new NumberCardViewModel(true, 0, '/Assets?filterType=ActiveOnly', '/Assets/Download?filterType=ActiveOnly&format=Excel'));
    //self.noAssetsWithIntent = ko.observable(new NumberCardViewModel(true, 0, '/Assets?filterType=Intent', '/Assets/Download?filterType=Intent&format=Excel'));
    //self.noAssetsOnExtension = ko.observable(new NumberCardViewModel(true, 0, '/Assets?filterType=Extension', '/Assets/Download?filterType=Extension&format=Excel'));
    //self.noSettledAssetsEOT = ko.observable(new NumberCardViewModel(true, 0, '/Assets?filterType=AssetStatus', '/Assets/Download?filterType=AssetStatus&format=Excel'));
    //self.noSettledAssetsPart = ko.observable(new NumberCardViewModel(true, 0, '/Assets?filterType=Settled', '/Assets/Download?filterType=Settled&format=Excel'));
    //self.noAssetsExpiring = ko.observable(new NumberCardViewModel(true, 0, '/Assets?filterType=Expiring', '/Assets/Download?filterType=Expiring&format=Excel'));

    //self.noQrentSADeals = ko.observable(new NumberCardViewModel(true, 0, '/QrentSA/Contracts?filterType=ActiveOnly', '/QrentSA/Contracts/Download?filterType=ActiveOnly&format=Excel'));
    //self.noQrentSAAssets = ko.observable(new NumberCardViewModel(true, 0, '/QrentSA/Assets?filterType=ActiveOnly', '/QrentSA/Assets/Download?filterType=ActiveOnly&format=Excel'));
    //self.noQrentSAAssetsWithIntent = ko.observable(new NumberCardViewModel(true, 0, '/QrentSA/Assets?filterType=Intent', '/QrentSA/Assets/Download?filterType=Intent&format=Excel'));
    //self.noQrentSAAssetsOnExtension = ko.observable(new NumberCardViewModel(true, 0, '/QrentSA/Assets?filterType=Extension', '/QrentSA/Assets/Download?filterType=Extension&format=Excel'));
    //self.noQrentSAAssetsExpiring = ko.observable(new NumberCardViewModel(true, 0, '/QrentSA/Assets?filterType=Expiring', '/QrentSA/Assets/Download?filterType=Expiring&format=Excel'));
    //self.noAmsaLocations = ko.observable(new NumberCardViewModel(true, 0, '/QrentSA/Assets?filterType=ActiveOnly', '/QrentSA/Assets/Download?filterType=ActiveOnly&format=Excel'));
    //self.noAmsaDevices = ko.observable(new NumberCardViewModel(true, 0, '/QrentSA/Assets?filterType=ActiveOnly', '/QrentSA/Assets/Download?filterType=ActiveOnly&format=Excel'));


    self.unreadCount = ko.observable(0);
    self.showUnreadCount = ko.observable(false);
    self.connection = connection;
    self.connection.hub.logging = true;
    self.connection.hub.error(function (error) {
        console.error('SignalR error: ' + error)
    });
    self.chat = self.connection.messagingHub;
    self.dashboardHub = self.connection.dashboardHub;
    self.error = ko.observable('');

    //AMSA customizations
    self.amsaLocations = ko.observableArray();
    self.amsaDevices = ko.observableArray();
    self.error = ko.observable('');
   
    function ajaxHelper(uri, method, data) {
        self.error(''); // Clear error message
        return $.ajax({
            type: method,
            url: uri,
            dataType: 'json',
            contentType: 'application/json',
            data: data ? JSON.stringify(data) : null
        }).fail(function (jqXHR, textStatus, errorThrown) {
            self.error(errorThrown);
        });
    }

    var AMSALocationViewModel = function (location, text) {
        var self = this;

        self.location = ko.observable(location);
        self.text = ko.observable(text);

    };

    var AMSADevicesViewModel = function (devices, text) {
        var self = this;

        self.devices = ko.observable(devices);
        self.text = ko.observable(text);

    };

    var customerCode = _customerCode;
    var crmCode = _crmCode;

    if (customerCode === undefined || customerCode === null || customerCode === '') {
        if (window.localStorage.getItem('custCode') !== undefined && window.localStorage.getItem('custCode') !== null && window.localStorage.getItem('custCode').toString() !== '') {
            customerCode = window.localStorage.getItem('custCode').toString();
        }
    }

    //get customerNames for dropdown list
    function getCustomerNames() {
        self.custList.removeAll();

        ajaxHelper('/api/Users/GetCustomers', 'GET').done(function (data) {
            self.custList.push(new CustomerViewModel('ALL', 'ALL'));

            for (var i = 0; i < data.length; i++) {
                self.custList.push(new CustomerViewModel(data[i].CustomerCode, data[i].CustomerName));
            }

            if ($('#custDashBoard').length === 0) {
                //if (self.isCustomerType1() || self.isCustomerType3()) {
                //    getNoDeals();
                //    getNoAssets();
                //    getNoAssetsWithIntent();
                //    getNoSettledAssetsEOT();
                //    getNoSettledAssetsPart();
                //    getNoAssetsOnExtension();
                //    getNoAssetsExpiring();
                //}

                //if (self.isCustomerType2()) {
                //    getNoQrentSADeals();
                //    getNoQrentSAAssets();
                //    getNoQrentSAAssetsWithIntent();
                //    getNoQrentSAAssetsOnExtension();
                //    getNoQrentSAAssetsExpiring();
                //}
            } else {
                $('#custDashBoard').dropdown('refresh');

                if ($('#custDashBoard').dropdown('get value') !== '')
                    $('#custDashBoard').dropdown('set selected', $('#custDashBoard').dropdown('get value'));
                else if (window.localStorage.getItem('custCode') !== undefined && window.localStorage.getItem('custCode') !== null && window.localStorage.getItem('custCode').toString() !== '')
                    $('#custDashBoard').dropdown('set selected', window.localStorage.getItem('custCode').toString());
                else
                    $('#custDashBoard').dropdown('set selected', self.custList()[0]);

                //customerDashboard for CRM
                $('#custDashBoard').on('change', function () {
                    if ($('#custDashBoard').dropdown('get value') !== '')
                        localStorage.setItem("custCode", $('#custDashBoard').dropdown('get value'));

                    var custCode = window.localStorage.getItem('custCode');

                    if (custCode === null) {
                        localStorage.setItem("custCode", '');
                        custCode = window.localStorage.getItem('custCode');
                    }

                    customerCode = custCode;
                    //console.log('refresh databoard data: ' + custCode.toString());

                    if ($('#loadingDashboard').css('display') === 'none') {
                        $('#loadingDashboard').show();
                        self.error('');
                        self.dashboardHub.server.refreshDashboard(customerCode === undefined || customerCode === null || customerCode === '' || (customerCode !== undefined && customerCode !== null && customerCode.toLowerCase() === "all") ? null : customerCode, null).done(function (msg) {
                            console.debug(msg);
                            var json = JSON.parse(msg);
                            $('#loadingDashboard').hide();
                            updateDashboard(json);
                        }).fail(function (error) {
                            $('#loadingDashboard').hide();
                            console.error('Invocation of refreshDashboard failed. Error: ' + error);
                            self.error('There was an error retrieving the data');
                        });
                    }

                    if ($('#myCustomersMenu > div.ui.dropdown.item').length !== 0) {
                        $('#myCustomersMenu > div.ui.dropdown.item').dropdown('set selected', custCode.toString());

                        $("#myCustomersMenu > div.ui.dropdown.item > div.menu > div.item").each(function (index) {
                            if ($(this).attr('data-value') === custCode.toString()) {
                                $("#myCustomersMenu > div.ui.dropdown.item").contents().filter(function () {
                                    return this.nodeType === 3;
                                })[0].nodeValue = $($("#myCustomersMenu > div.ui.dropdown.item > div.menu > div.item")[index]).text();

                                return;
                            }
                        });
                    }
                });

                $('#custDashBoard').change();
            }
        });
    }

    //getMercPayerBans
    var MercBansViewModel = function (ban, text) {
        var self = this;

        self.ban = ko.observable(ban);
        self.text = ko.observable(text);
    };

    self.payerBans = ko.observableArray();

    self.connection.hub.start().done(function () {
        getCustomerNames();

        if ($('#payerBans').length > 0) {
            self.dashboardHub.server.getMercPayerbans().done(function (data) {
                if (data.length > 0) {
                    self.payerBans.removeAll();
                    var payerBan = localStorage.getItem("payerBan") !== null ? localStorage.getItem("payerBan") : 'All';
                    self.payerBans.push(new MercBansViewModel("All", "All assets/contracts"));

                    for (var i = 0; i < data.length; i++) {
                        self.payerBans.push(new MercBansViewModel(data[i], data[i]));
                    }

                    $('#payerBans').dropdown({
                        onChange: function (value, text, $selectedItem) {
                            localStorage.setItem("payerBan", value);

                            self.dashboardHub.server.refreshDashboard("001088", value).done(function (msg) {
                                var json = JSON.parse(msg);
                                console.log(json);
                                updateDashboard(json);
                            });
                        }
                    });

                    $('#payerBans').dropdown('set selected', payerBan);
                }

                self.dashboardHub.server.refreshDashboard("001088", localStorage.getItem("payerBan") !== null ? localStorage.getItem("payerBan") : 'All').done(function (msg) {
                    var json = JSON.parse(msg);
                    $('#loadingDashboard').hide();
                    updateDashboard(json);
                });
            });
        } else if ($('#amsaLocations').length > 0) {
            self.dashboardHub.server.getAMSALocations().done(function (data) {
                //get amsa location
                if (data.length > 0) {
                    self.amsaLocations.removeAll();
                    var amsaLocation = localStorage.getItem("amsaLocation") !== null ? localStorage.getItem("amsaLocation").toString() : 'All';
                    self.amsaLocations.push(new AMSALocationViewModel("All", "All locations"));

                    for (var i = 0; i < data.length; i++) {
                        self.amsaLocations.push(new AMSALocationViewModel(data[i], data[i]));
                    }

                    $('#amsaLocations').dropdown({
                        onChange: function (value, text, $selectedItem) {
                            localStorage.setItem("amsaLocation", value);

                            var amsaDevice = localStorage.getItem("amsaDevice") !== null ? localStorage.getItem("amsaDevice").toString() : 'All';
                            //console.log('location change: ' + value + "---" + amsaDevice);
                            self.dashboardHub.server.refreshAMSADashboard(value, amsaDevice).done(function (msg) {
                                var json = JSON.parse(msg);
                                $('#loadingDashboard').hide();
                                updateDashboard(json);
                            });
                        }
                    });

                    $('#amsaLocations').dropdown('set selected', amsaLocation.toString());

                    self.dashboardHub.server.getAMSAAssetTypes().done(function (data) {
                        //get amsa device type
                        if (data.length > 0) {

                            self.amsaDevices.removeAll();
                            var amsaDevice = localStorage.getItem("amsaDevice") !== null ? localStorage.getItem("amsaDevice").toString() : 'All';
                            self.amsaDevices.push(new AMSADevicesViewModel("All", "All asset types"));

                            for (var i = 0; i < data.length; i++) {
                                self.amsaDevices.push(new AMSADevicesViewModel(data[i], data[i]));
                            }

                            $('#amsaDevices').dropdown({
                                onChange: function (value, text, $selectedItem) {
                                    localStorage.setItem("amsaDevice", value);

                                    var amsaLocation = localStorage.getItem("amsaLocation") !== null ? localStorage.getItem("amsaLocation").toString() : 'All';
                                    //console.log('device type change: ' + amsaLocation + "---" + value);
                                    self.dashboardHub.server.refreshAMSADashboard(amsaLocation, value).done(function (msg) {
                                        var json = JSON.parse(msg);
                                        console.log(json);
                                        updateDashboard(json);
                                    });
                                }
                            });

                            $('#amsaDevices').dropdown('set selected', amsaDevice.toString());

                            //console.log('get dashboard: ' + amsaLocation + "---" + amsaDevice);
                            self.dashboardHub.server.refreshAMSADashboard(amsaLocation, amsaDevice).done(function (msg) {
                                var json = JSON.parse(msg);
                                $('#loadingDashboard').hide();
                                updateDashboard(json);
                            });
                        }
                    });
                }
            });
        } else {
            self.error('');
            self.dashboardHub.server.refreshDashboard(customerCode === undefined || customerCode === null || customerCode === '' || (customerCode !== undefined && customerCode !== null && customerCode.toLowerCase() === "all") ? null : customerCode, null).done(function (msg) {
                console.debug(msg);
                var json = JSON.parse(msg);
                $('#loadingDashboard').hide();
                updateDashboard(json);
            }).fail(function (error) {
                $('#loadingDashboard').hide();
                console.error('Invocation of refreshDashboard failed. Error: ' + error);
                self.error('There was an error retrieving the data');
            });
        }
        //$.ajax('/api/Messaging/Notifications', {
        //    method: 'GET',
        //    dataType: 'json'
        //}).done(function (data) {
        //    self.unreadCount(data.UnreadCount);
        //});
    });

    self.chat.client.updateUnreadCount = function (fromUser, unreadCount) {
        self.unreadCount(unreadCount);
        $.notification('CAMS Portal Notification', 'You have new unread messages', null, null);
    };

    self.chat.client.showErrorMessage = function (message) {
        console.log(message);
    };

    function updateDashboard(json) {
        if (json.innovent !== undefined) {
            var foundCompany = false;

            for (var i = 0; i < self.companies().length; i++) {
                if (self.companies()[i].name() === "Innovent") {
                    foundCompany = true;
                    self.companies()[i].noDeals().number(json.innovent.noDeals);
                    self.companies()[i].noAssets().number(json.innovent.noAssets);
                    self.companies()[i].noAssetsWithIntent().number(json.innovent.noAssetsWithIntent);
                    self.companies()[i].noAssetsOnExtension().number(json.innovent.noAssetsOnExtension);
                    self.companies()[i].noAssetsExpiring().number(json.innovent.noAssetsExpiring);
                    self.companies()[i].noAssetsSettledEOT().number(json.innovent.noAssetsSettledEOT);
                    self.companies()[i].noAssetsSettledPart().number(json.innovent.noAssetsSettledPart);

                    break;
                }
            }

            if (!foundCompany)
                self.companies.push(new CompanyViewModel("Innovent", '', json.innovent.noDeals, json.innovent.noAssets, json.innovent.noAssetsWithIntent, json.innovent.noAssetsOnExtension, json.innovent.noAssetsExpiring, json.innovent.noAssetsSettledEOT, json.innovent.noAssetsSettledPart));
        } else {
            for (var i = 0; i < self.companies().length; i++) {
                if (self.companies()[i].name() === "Innovent") {
                    self.companies.remove(self.companies()[i]);
                    break;
                }
            }
        }

        if (json.lenovo !== undefined) {
            var foundCompany = false;

            for (var i = 0; i < self.companies().length; i++) {
                if (self.companies()[i].name() === "Lenovo Financial Services") {
                    foundCompany = true;
                    self.companies()[i].noDeals().number(json.lenovo.noDeals);
                    self.companies()[i].noAssets().number(json.lenovo.noAssets);
                    self.companies()[i].noAssetsWithIntent().number(json.lenovo.noAssetsWithIntent);
                    self.companies()[i].noAssetsOnExtension().number(json.lenovo.noAssetsOnExtension);
                    self.companies()[i].noAssetsExpiring().number(json.lenovo.noAssetsExpiring);

                    break;
                }
            }

            if (!foundCompany)
                self.companies.push(new CompanyViewModel("Lenovo Financial Services", '', json.lenovo.noDeals, json.lenovo.noAssets, json.lenovo.noAssetsWithIntent, json.lenovo.noAssetsOnExtension, json.lenovo.noAssetsExpiring));
        } else {
            for (var i = 0; i < self.companies().length; i++) {
                if (self.companies()[i].name() === "Lenovo Financial Services") {
                    self.companies.remove(self.companies()[i]);
                    break;
                }
            }
        }

        if (json.qrent !== undefined) {
            var foundCompany = false;

            for (var i = 0; i < self.companies().length; i++) {
                if (self.companies()[i].name() === "Qrent") {
                    foundCompany = true;
                    self.companies()[i].noDeals().number(json.qrent.noDeals);
                    self.companies()[i].noAssets().number(json.qrent.noAssets);
                    self.companies()[i].noAssetsWithIntent().number(json.qrent.noAssetsWithIntent);
                    self.companies()[i].noAssetsOnExtension().number(json.qrent.noAssetsOnExtension);
                    self.companies()[i].noAssetsExpiring().number(json.qrent.noAssetsExpiring);

                    break;
                }
            }

            if (!foundCompany)
                self.companies.push(new CompanyViewModel("Qrent", '/QrentSA', json.qrent.noDeals, json.qrent.noAssets, json.qrent.noAssetsWithIntent, json.qrent.noAssetsOnExtension, json.qrent.noAssetsExpiring));
        } else {
            for (var i = 0; i < self.companies().length; i++) {
                if (self.companies()[i].name() === "Qrent") {
                    self.companies.remove(self.companies()[i]);
                    break;
                }
            }
        }
    }

    self.dashboardHub.client.updateDashboard = function () {
        if ($('#payerBans').length > 0) {
            self.dashboardHub.server.getMercPayerbans().done(function (data) {
                if (data.length > 0) {
                    self.payerBans.removeAll();
                    var payerBan = localStorage.getItem("payerBan") !== null ? localStorage.getItem("payerBan") : 'All';
                    self.payerBans.push(new MercBansViewModel("All", "All assets/contracts"));

                    for (var i = 0; i < data.length; i++) {
                        self.payerBans.push(new MercBansViewModel(data[i], data[i]));
                    }

                    $('#payerBans').dropdown({
                        onChange: function (value, text, $selectedItem) {
                            localStorage.setItem("payerBan", value);

                            self.dashboardHub.server.refreshDashboard("001088", value).done(function (msg) {
                                var json = JSON.parse(msg);
                                console.log(json);
                                updateDashboard(json);
                            });
                        }
                    });

                    $('#payerBans').dropdown('set selected', payerBan);
                }

                self.dashboardHub.server.refreshDashboard("001088", localStorage.getItem("payerBan") !== null ? localStorage.getItem("payerBan") : 'All').done(function (msg) {
                    var json = JSON.parse(msg);
                    //console.log(json);
                    $('#loadingDashboard').hide();
                    updateDashboard(json);
                });
            });
        } else if ($('#amsaLocations').length > 0) {
            self.dashboardHub.server.getAMSALocations().done(function (data) {
                //get amsa location
                if (data.length > 0) {
                    self.amsaLocations.removeAll();
                    var amsaLocation = localStorage.getItem("amsaLocation") !== null ? localStorage.getItem("amsaLocation").toString() : 'All';
                    self.amsaLocations.push(new AMSALocationViewModel("All", "All locations"));

                    for (var i = 0; i < data.length; i++) {
                        self.amsaLocations.push(new AMSALocationViewModel(data[i], data[i]));
                    }

                    $('#amsaLocations').dropdown({
                        onChange: function (value, text, $selectedItem) {
                            localStorage.setItem("amsaLocation", value);

                            var amsaDevice = localStorage.getItem("amsaDevice") !== null ? localStorage.getItem("amsaDevice").toString() : 'All';
                            //console.log('location change: ' + value + "---" + amsaDevice);
                            self.dashboardHub.server.refreshAMSADashboard(value, amsaDevice).done(function (msg) {
                                var json = JSON.parse(msg);
                                console.log(json);
                                updateDashboard(json);
                            });
                        }
                    });

                    $('#amsaLocations').dropdown('set selected', amsaLocation.toString());

                    self.dashboardHub.server.getAMSAAssetTypes().done(function (data) {
                        //get amsa device type
                        if (data.length > 0) {

                            self.amsaDevices.removeAll();
                            var amsaDevice = localStorage.getItem("amsaDevice") !== null ? localStorage.getItem("amsaDevice").toString() : 'All';
                            self.amsaDevices.push(new AMSADevicesViewModel("All", "All asset types"));

                            for (var i = 0; i < data.length; i++) {
                                self.amsaDevices.push(new AMSADevicesViewModel(data[i], data[i]));
                            }

                            $('#amsaDevices').dropdown({
                                onChange: function (value, text, $selectedItem) {
                                    localStorage.setItem("amsaDevice", value);

                                    var amsaLocation = localStorage.getItem("amsaLocation") !== null ? localStorage.getItem("amsaLocation").toString() : 'All';
                                    //console.log('device type change: ' + amsaLocation + "---" + value);
                                    self.dashboardHub.server.refreshAMSADashboard(amsaLocation, value).done(function (msg) {
                                        var json = JSON.parse(msg);
                                        console.log(json);
                                        updateDashboard(json);
                                    });
                                }
                            });

                            $('#amsaDevices').dropdown('set selected', amsaDevice.toString());

                            //console.log('get dashboard: ' + amsaLocation + "---" + amsaDevice);
                            self.dashboardHub.server.refreshAMSADashboard(amsaLocation, amsaDevice).done(function (msg) {
                                var json = JSON.parse(msg);
                                $('#loadingDashboard').hide();
                                updateDashboard(json);
                            });
                        }
                    });
                }
            });
        } else {
            self.dashboardHub.server.refreshDashboard(customerCode === undefined || customerCode === null || customerCode === '' || (customerCode !== undefined && customerCode !== null && customerCode.toLowerCase() === "all") ? null : customerCode, null).done(function (msg) {
                var json = JSON.parse(msg);
                $('#loadingDashboard').hide();
                updateDashboard(json);
            });
        }
    };

    self.downloadInfo = function (card) {
        $.ajax(card.downloadLink(), {
            type: 'POST',
            dataType: 'binary',
            processData: false,
            success: function (data, textStatus, jqXHR) {
                if (!showSave) {
                    alert("Your browser does not support any method of saving JavaScript generated data to files.");
                    return;
                }

                var filename = '';
                var disposition = jqXHR.getResponseHeader('Content-Disposition');

                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches !== null && matches[1]) filename = matches[1].replace(/['"]/g, "");
                }

                var mimeType = jqXHR.getResponseHeader('Content-Type');

                showSave(data, filename, 'application/octet-stream');
            }
        });
    };
};

//customer dashboard dropdown list customization
var CustomerViewModel = function (code, name) {
    var self = this;

    self.code = ko.observable(code);
    self.name = ko.observable(name + ' (' + code + ')');
};

//var FacilityViewModel = function (connection) {
//    var self = this;
//    self.unreadCount = ko.observable(0);
//    self.showUnreadCount = ko.observable(false);
//    self.connection = connection;
//    self.chat = self.connection.messagingHub;
//    self.error = ko.observable();

//    var facilitiesUri = '/api/Facilities';

//    function ajaxHelper(uri, method, data) {
//        self.error(''); // Clear error message
//        return $.ajax({
//            type: method,
//            url: uri,
//            dataType: 'json',
//            contentType: 'application/json',
//            data: data ? JSON.stringify(data) : null
//        }).fail(function (jqXHR, textStatus, errorThrown) {
//            self.error(errorThrown);
//        });
//    }

//    function getFacilities() {
//        //ajaxHelper(customersUri, 'GET').done(function (data) {
//        //self.customers(data);
//        self.error('');
//        $('.ui.active.dimmer').removeClass("disabled").addClass("active");
//        $('.table').DataTable({
//            "serverSide": true,
//            "ajax": {
//                type: 'GET',
//                url: facilitiesUri,
//                dataType: 'json',
//                contentType: 'application/json',
//                dataSrc: function (json) {
//                    $('.ui.active.dimmer').removeClass("active").addClass("disabled");

//                    return json.data;
//                }
//            },
//            "columns": [
//                {
//                    "data": "FunderName"
//                    //"render": function (data, type, full, meta) {
//                    //    if (data != null)
//                    //        return '<a href="/Facilities">' + data + '</a>';
//                    //    else
//                    //        return data;
//                    //}
//                },
//                {
//                    "data": "TotalAvailable"
//                    //"render": function (data, type, full, meta) {
//                    //    if (data != null)
//                    //        return '<a href="/Facilities/' + full.ActorCode + '">' + data + '</a>';
//                    //    else
//                    //        return data;
//                    //}
//                },
//                {
//                    "data": "NumberOfCustomers"
//                    //"render": function (data, type, full, meta) {
//                    //    if (data != null)
//                    //        return '<a href="/Customers/' + full.ActorCode + '">' + data + '</a>';
//                    //    else
//                    //        return data;
//                    //}
//                }
//            ],
//            "order": [[1, "asc"]],
//            stateSave: true
//        });

//        //$('.ui.active.dimmer').removeClass("active").addClass("disabled");
//        //});
//    }

//    self.connection.hub.start().done(function () {
//    });

//    self.chat.client.updateUnreadCount = function (fromUser, unreadCount) {
//        self.unreadCount(unreadCount);
//    };

//    // Fetch the initial data.
//    getFacilities();
//};

//var AssetMasterSheetViewModel = function (_columnDefs, connection) {
//    var self = this;
//    self.unreadCount = ko.observable(0);
//    self.showUnreadCount = ko.observable(false);
//    self.connection = connection;
//    self.chat = self.connection.messagingHub;
//    self.error = ko.observable();

//    var columnDefs = _columnDefs;
//    var assetsUri = '/api/Assets/MasterSheet';

//    function ajaxHelper(uri, method, data) {
//        self.error(''); // Clear error message
//        return $.ajax({
//            type: method,
//            url: uri,
//            dataType: 'json',
//            contentType: 'application/json',
//            data: data ? JSON.stringify(data) : null
//        }).fail(function (jqXHR, textStatus, errorThrown) {
//            self.error(errorThrown);
//        });
//    }

//    function getAssets() {
//        self.error('');
//        $.fn.DataTable.ext.buttons.saveToExcel = {
//            extend: 'excel',
//            text: '<i class="download icon"></i> Download',
//            action: function () {
//                $('.page.dimmer:first div.ui.text.loader').text('Conceiving perceptions and calibrating expectations for your download request... Please wait.');
//                $('.page.dimmer:first').dimmer('set active');

//                $.ajax('/Reports/MasterSheet/Download/Excel', {
//                    type: 'GET',
//                    dataType: 'binary',
//                    processData: false,
//                    success: function (data, textStatus, jqXHR) {
//                        if (!showSave) {
//                            alert("Your browser does not support any method of saving JavaScript gnerated data to files.");
//                            return;
//                        }

//                        var filename = '';
//                        var disposition = jqXHR.getResponseHeader('Content-Disposition');

//                        if (disposition && disposition.indexOf('attachment') !== -1) {
//                            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
//                            var matches = filenameRegex.exec(disposition);
//                            if (matches !== null && matches[1]) filename = matches[1].replace(/['"]/g, "");
//                        }

//                        var mimeType = jqXHR.getResponseHeader('Content-Type');
//                        $('.page.dimmer:first').dimmer('set disabled');
//                        $('.page.dimmer:first').removeClass('active').removeClass('disabled');

//                        showSave(data, filename, 'application/octet-stream');
//                    }
//                });
//            }
//        };

//        var table = $('#tblAssets')
//            .on('processing.dt', function (e, settings, processing) {
//                self.error('');
//                if (processing && !$('#divAssets').hasClass('loading'))
//                    $('#divAssets').addClass("loading");
//                else
//                    $('#divAssets').removeClass("loading");

//                $('.isdatefield', $('#tblAssets tbody')).each(function () { if ($(this).text() !== "") $(this).text(moment.utc($(this).text()).format('YYYY-MM-DD')); });
//                AutoNumeric.multiple('#tblAssets > tbody > tr > td.ismoney', { digitGroupSeparator: ' ', currencySymbol: 'R ' });

//                $.fn.DataTable.tables({ visible: true, api: true }).columns.adjust();
//            }).on('column-visibility.dt', function (e, settings, column, state) {
//                $('.isdatefield', $('#tblAssets tbody')).each(function () { if ($(this).text() !== "") $(this).text(moment.utc($(this).text()).format('YYYY-MM-DD')); });
//                AutoNumeric.multiple('#tblAssets > tbody > tr > td.ismoney', { digitGroupSeparator: ' ', currencySymbol: 'R ' });
//                $.fn.DataTable.tables({ visible: true, api: true }).columns.adjust();
//            })
//            .DataTable({
//                lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
//                pagingType: "full",
//                serverSide: true,
//                scrollX: true,
//                dom: "<'ui grid'<'row'<'left aligned two wide column'l><'left aligned ten wide column'B><'right aligned four wide column'f>><'row dt-table'<'sixteen wide column'tr>><'row'<'six wide column'i><'right aligned ten wide column'p>>>",
//                //dom: "<'ui grid'<'row'<'twelve wide column'<'ui grid'<'row'<'six wide tablet four wide computer column'l><'ten wide tablet twelve wide computer column'B>>>><'right aligned four wide column'f>><'row dt-table'<'sixteen wide column'tr>><'row'<'seven wide column'i><'right aligned nine wide column'p>>>",
//                buttons: [{
//                    extend: 'colvis',
//                    text: '<i class="checkmark box icon"></i> Select Columns'
//                }, {
//                    extend: 'colvisGroup',
//                    text: '<i class="expand icon"></i> Show All',
//                    show: ':hidden'
//                }, {
//                    extend: 'colvisRestore',
//                    text: '<i class="undo icon"></i> Restore Columns'
//                }, {
//                    extend: 'saveToExcel'
//                }],
//                "ajax": {
//                    type: 'POST',
//                    url: assetsUri,
//                    dataType: 'json',
//                    dataSrc: function (json) {
//                        return json.data;
//                    },
//                    complete: function (xhr, textStatus) {
//                        if (textStatus !== 'success') {
//                            self.error('No Assets Found');
//                        }

//                        //$('#tblAssets tbody tr td:nth-child(3), #tblDeals tbody tr td:nth-child(4)').each(function () { $(this).text(moment.utc($(this).text()).format('YYYY-MM-DD')) });
//                        //$('#tblAssets tbody tr td:nth-child(6), #tblAssets tbody tr td:nth-child(7), #tblAssets tbody tr td:nth-child(8)').each(function () { $(this).autoNumeric('init', { digitGroupSeparator: ' ', currencySymbol: 'R ' }) });
//                    }
//                },
//                "columns": columnDefs
//                //"order": [[1, "asc"]],
//                //stateSave: true
//        });
//    }

//    self.connection.hub.start().done(function () {
//        $.ajax('/api/Messaging/Notifications', {
//            method: 'GET',
//            dataType: 'json'
//        }).done(function (data) {
//            self.unreadCount(data.UnreadCount);
//        });
//    });

//    self.chat.client.updateUnreadCount = function (fromUser, unreadCount) {
//        self.unreadCount(unreadCount);
//    };

//    // Fetch the initial data.
//    getAssets();
//};

var MessagingViewModel = function (userId, connection) {
    var self = this;
    self.error = ko.observable();
    self.currentUserId = userId;
    self.threads = ko.observableArray();
    self.threadHeading = ko.observable('Select user on left to start messaging');
    self.threadMessages = ko.observableArray();
    self.showReplyForm = ko.observable(false);
    self.unreadCount = ko.observable(0);
    self.showUnreadCount = ko.observable(false);
    self.connection = connection;
    self.chat = self.connection.messagingHub;

    var messagingUri = '/api/Messaging';

    function ajaxHelper(uri, method, data) {
        self.error(''); // Clear error message
        return $.ajax({
            type: method,
            url: uri,
            dataType: 'json',
            contentType: 'application/json',
            data: data ? JSON.stringify(data) : null
        }).fail(function (jqXHR, textStatus, errorThrown) {
            self.error(errorThrown);
        });
    }

    function getThreads() {
        // Start the connection.
        self.connection.hub.start().done(function () {
            $('#btnAddReply').click(function (e) {
                e.preventDefault();

                if ($('#replyMessage').val() !== '' && !$('#btnAddReply').hasClass('loading')) {
                    //console.log($('#replyMessage').val());
                    $('#btnAddReply').addClass('loading');
                    self.chat.server.sendMessage(self.currentUserId, $('#replyMessage').val());
                    //var data = { FromName: 'Me', DateSet: Date(), MessageBody: $('#replyMessage').val() }; //JSON.parse(message);
                    //self.threadMessages.push(data);
                    $('#replyMessage').val('');
                    $('#btnAddReply').removeClass('loading');
                }
            });
        });

        ajaxHelper(messagingUri, 'GET').done(function (data) {
            self.threads(data);

            if (self.currentUserId !== undefined && self.currentUserId !== null)
                getThreadMessages(self.currentUserId);
            else if (data.length > 0)
                getThreadMessages(data[0].UserId);

            $('a.item.threadMessage').click(function (e) {
                e.preventDefault();

                getThreadMessages($(this).attr('data-userId'));
            });
        });
    }

    function getThreadMessages(userId) {
        self.currentUserId = userId;
        self.showReplyForm(false);
        $('div.ui.grid.horizontal.segments > div:nth-child(2)').addClass('loading');
        $('a.item.threadMessage.active').removeClass('active');
        ajaxHelper(messagingUri + '/Thread/' + userId, 'GET').done(function (data) {
            //updateNotifications();
            //if (data != null && data.length > 0) {
            var threads = [];
            var totalUnread = 0;
            self.threadMessages(data);

            for (var i = 0; i < self.threads().length; i++) {
                var thread = {
                    UserId: self.threads()[i].UserId,
                    Name: self.threads()[i].Name,
                    Description: self.threads()[i].Description,
                    UnreadCount: self.threads()[i].UnreadCount,
                    Connected: self.threads()[i].Connected
                };

                if (thread.UserId === userId) {
                    thread.UnreadCount = 0;
                }

                totalUnread += thread.UnreadCount;

                threads.push(thread);
            }

            self.unreadCount(totalUnread);
            self.threads(threads);
            $('a.item.threadMessage[data-userId=' + userId + ']').addClass('active');
            self.threadHeading('Messages with ' + $('a.item.threadMessage.active > div:nth-child(2) > div.header > span').text());
            $('a.item.threadMessage').click(function (e) {
                e.preventDefault();

                getThreadMessages($(this).attr('data-userId'));
            });

            //}
            self.showReplyForm(true);
            $('div.ui.grid.horizontal.segments > div:nth-child(2)').removeClass('loading');
        });
    }

    function addReplyMessage(userId, messageBody) {
        $('#btnAddReply').addClass('loading');
        ajaxHelper(messagingUri, 'POST', {
            To: userId,
            MessageBody: messageBody
        }).done(function (data) {
            $('#replyMessage').val('');
            self.threadMessages.push(data);
            $('#btnAddReply').removeClass('loading');
        });
    }

    //$('#btnAddReply').click(function (e) {
    //    e.preventDefault();

    //    addReplyMessage(self.currentUserId, $('#replyMessage').val());
    //});

    getThreads();

    self.chat.client.addMessage = function (fromUser, message) {
        var data = JSON.parse(message);

        if (fromUser === self.currentUserId) {
            self.threadMessages.push(data);
            self.chat.server.messageRead(data.Id);
            var totalUnread = 0;

            for (var i = 0; i < self.threads().length; i++) {
                if (self.threads()[i].UserId !== fromUser) {
                    totalUnread += self.threads()[i].UnreadCount;
                }
            }

            self.unreadCount(totalUnread);
        }
    };

    self.chat.client.addOwnMessage = function (message) {
        var data = JSON.parse(message);
        self.threadMessages.push(data);
    };

    self.chat.client.updateUserUnreadCount = function (userId, unreadCount) {
        //console.log('Total unread messages for ' + userId + ': ' + unreadCount);

        ajaxHelper(messagingUri, 'GET').done(function (data) {
            self.threads(data);
            $('a.item.threadMessage[data-userId=' + self.currentUserId + ']').addClass('active');

            $('a.item.threadMessage').click(function (e) {
                e.preventDefault();
                getThreadMessages($(this).attr('data-userId'));
            });

            var totalUnread = 0;

            for (var i = 0; i < self.threads().length; i++) {
                if (self.threads()[i].UserId !== userId) {
                    totalUnread += self.threads()[i].UnreadCount;
                }
            }

            self.unreadCount(totalUnread);
        });
    };

    self.chat.client.updateUnreadCount = function (fromUser, unreadCount) {
        if (fromUser !== self.currentUserId)
            self.unreadCount(unreadCount);
    };

    self.chat.client.userConnected = function (userId) {
        var threads = [];

        for (var i = 0; i < self.threads().length; i++) {
            var thread = {
                UserId: self.threads()[i].UserId,
                Name: self.threads()[i].Name,
                Description: self.threads()[i].Description,
                UnreadCount: self.threads()[i].UnreadCount,
                Connected: self.threads()[i].Connected
            };

            if (thread.UserId === userId) {
                thread.Connected = true;
            }

            threads.push(thread);
        }

        self.threads(threads);
        $('a.item.threadMessage[data-userId=' + self.currentUserId + ']').addClass('active');

        $('a.item.threadMessage').click(function (e) {
            e.preventDefault();
            getThreadMessages($(this).attr('data-userId'));
        });
    };

    self.chat.client.userDisconnected = function (userId) {
        var threads = [];

        for (var i = 0; i < self.threads().length; i++) {
            var thread = {
                UserId: self.threads()[i].UserId,
                Name: self.threads()[i].Name,
                Description: self.threads()[i].Description,
                UnreadCount: self.threads()[i].UnreadCount,
                Connected: self.threads()[i].Connected
            };

            if (thread.UserId === userId) {
                thread.Connected = false;
            }

            threads.push(thread);
        }

        self.threads(threads);
        $('a.item.threadMessage[data-userId=' + self.currentUserId + ']').addClass('active');

        $('a.item.threadMessage').click(function (e) {
            e.preventDefault();
            getThreadMessages($(this).attr('data-userId'));
        });
    };

    self.chat.client.showErrorMessage = function (message) {
        self.error(message);
        //console.log(message);
    };



};

